import { render } from "./order_quantities_report.vue?vue&type=template&id=498acc2a"
import script from "./order_quantities_report.vue?vue&type=script&lang=js"
export * from "./order_quantities_report.vue?vue&type=script&lang=js"

import "./order_quantities_report.vue?vue&type=style&index=0&id=498acc2a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__